import React, { useEffect } from 'react';
import ProductsData from './productsData';
import SectionTitle from '../SectionTitle/SectionTitle';
import ProductCard from './ProductCard';
import ShapeOn from '../../images/services/bg.jpeg'; // same as ServiceSection

 
const Products = ({ hclass }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  return (
    <section className={`section-padding ${hclass}`}>
      <div className="top-img">
        <img src={ShapeOn} alt="Background Shape" />
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <SectionTitle
              title="Your Growth Partner in Every Solution"
              subtitle="Our Products"
            />
          </div>
        </div>

        <div className="services-wrap"> {/* same wrapper class */}
          <div className="row">
            {ProductsData.map((product, index) => (
              <div className="col col-xl-6 col-lg-6 col-md-6 col-12" key={index}>
                <ProductCard
                  img={product.sImg || product.img}
                  title={product.title}
                  description={product.description}
                  slug={product.slug}
                />
                
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
